
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberToArray',
    standalone: true
})
export class NumberToArrayPipe implements PipeTransform {
    transform(n: number): number[] {
      return Array.from(Array(n).keys())
    }
}
